import { userCurrentEnterprise } from 'spark-state/common/user/userReducer';

export const withEnterpriseId = (fn) => (...params) => (dispatch, getState) => {
	const actionCreator = fn(userCurrentEnterprise(getState()));

	if (typeof actionCreator !== 'function') {
		return dispatch(actionCreator);
	}

	return dispatch(actionCreator(...params));
};
